import React, { useEffect, useState } from "react";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          "https://prakruthi.vercel.app/api/product/all"
        );
        const data = await response.json();
        if (data.success) {
          setProducts(data.data);
        } else {
          setError("Failed to fetch products");
        }
      } catch (err) {
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading)
    return <div className="text-center text-lg font-semibold">Loading...</div>;
  if (error)
    return (
      <div className="text-red-600 text-center text-lg font-semibold">
        {error}
      </div>
    );

  return (
    <div className="bg-white shadow-lg rounded-lg p-6">
      <h2 className="font-bold text-lg text-gray-700 border-b pb-2 mb-4">
        Overall Inventory
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-blue-50 p-6 rounded-lg text-center shadow">
          <span className="text-blue-600 font-semibold text-xl">
            Total Products
          </span>
          <p className="text-gray-700 font-bold text-2xl mt-2">
            {products.length}
          </p>
          <p className="text-gray-400 text-sm">Last 7 days</p>
        </div>
        <div className="bg-yellow-50 p-6 rounded-lg shadow">
          <h3 className="text-yellow-600 font-semibold text-lg mb-3">
            Top Selling
          </h3>
          <div className="space-y-3">
            {products.slice(0, 5).map((product) => (
              <div key={product._id} className="flex items-center gap-4">
                <img
                  src={product.img}
                  alt={product.title}
                  className="w-12 h-12 rounded-lg shadow-md"
                />
                <span className="font-semibold text-gray-700">
                  {product.title}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-red-50 p-6 rounded-lg shadow">
          <h3 className="text-red-600 font-semibold text-lg mb-3">
            Low Stocks
          </h3>
          <div className="space-y-3">
            {products
              .filter((product) => product.quantity < 80)
              .map((product) => (
                <div key={product._id} className="flex items-center gap-4">
                  <img
                    src={product.img}
                    alt={product.title}
                    className="w-12 h-12 rounded-lg shadow-md"
                  />
                  <span className="font-semibold text-gray-700">
                    {product.title}
                  </span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductList;
